export enum ConfigTemplate {
  Fresh = "fresh",
  Gate1 = "gate1",
}
